import SearchModuleSpecialRates from './SearchModuleSpecialRates';

export default SearchModuleSpecialRates;
